module.exports = "/_next/static/images/3687dd880e367e1187659163b13bfbc1-cajita-xs.png";